import React, { Component } from "react";
import { adminService, networkErrorHelper } from "libs";
import { MnemoLoading, ModalHandler, Title } from "components/misc";
import { loginByUserId } from "store/actions";
import { Button, Col, Container, Row } from "design-react-kit";
import RevisorDetailAccount from "./RevisorDetailAccount";
import { AdminRevisorForm } from "components/forms/admin";
import { IoMdArrowBack } from "react-icons/io";
import { NavLink, withRouter } from "react-router-dom";
import { ROUTES } from "const";
import { connect } from "react-redux";

class RevisorDetail extends Component {
  state = {
    whereObj: {
      id: this.props.match.params.id,
      role: this.props.match.params.role,
      context: this.props.match.params.context,
    },
    loading: false,
    detail: {
      user: false,
      profile: false,
      revisor: false,
    },
  };

  componentDidMount() {
    this.loadRemote(this.state.whereObj);
  }

  loadRemote(whereObj) {
    this.setState({ loading: true });

    adminService
      .userDetail(whereObj)
      .then(({ data }) => {
        const { user, profile, revisor } = data.payload.resObj;

        this.setState({
          detail: {
            user,
            profile,
            revisor,
          },
          loading: false,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false });
      });
  } //loadRemote

  /** Personification */
  personification = (userId) => {
    const code = (
      <>
        <p>Vuoi sloggarti e riloggarti con l'account selezionato?</p>
      </>
    );
    ModalHandler.show(
      userId,
      "Attenzione",
      code,
      null,
      this.runPersonification
    );
  }; //personification

  runPersonification = (userId) => {
    this.props.loginByUserId(userId, "/dashboard");
  };

  render() {
    const { user, profile, revisor } = this.state.detail;
    const { loading, whereObj } = this.state;
    if (loading) return <MnemoLoading />;

    return (
      <section className="my-4">
        <Row className="mb-2">
          <Col className="text-right">
            <NavLink
              to={`${ROUTES.USER_LIST}/revisor`}
              className="btn btn-primary bg-dark"
            >
              <IoMdArrowBack className="mb-1 mr-1" /> Torna alla lista revisori
            </NavLink>
          </Col>
        </Row>

        <Title>
          <Row>
            <Col lg={{ size: 6 }}>Dettaglio Revisore</Col>
            <Col className="text-right">
              <Button
                color="btn btn-primary bg-danger m-1 p-3"
                onClick={(e) => this.personification(whereObj.id)}
              >
                Login come {user.name + " " + user.surname}
              </Button>
            </Col>
          </Row>
        </Title>

        <Container>
          <RevisorDetailAccount data={{ user, profile }} />

          <AdminRevisorForm revisor={revisor} />
        </Container>
      </section>
    );
  }
}

const stateToProps = ({ app }) => {
  return {
    msgLogin: app.error,
  };
};

const dispatchToProps = (dispatch) => {
  return {
    loginByUserId(userId, redirectUrl) {
      dispatch(loginByUserId(userId, redirectUrl));
    },
  };
};

export default connect(
  stateToProps,
  dispatchToProps
)(withRouter(RevisorDetail));
